import { defineMessages } from 'react-intl';
import {
  addDefaultOptions,
  templatesOptions,
  addLinkMoreOptions,
  addSchemaField,
} from 'design-comuni-plone-theme/config/Blocks/ListingOptions';

import { cloneBlock } from 'design-comuni-plone-theme/helpers/blocks';
import TimelineTemplate from 'rer-theme/components/Blocks/Listing/Timeline/TimelineTemplate';
import TimelineTemplateSkeleton from 'rer-theme/components/Blocks/Listing/Timeline/Skeleton';

export const addListingVariation_Timeline = (config) => {
  config.blocksConfig.listing.variations = [
    ...config.blocksConfig.listing.variations,
    {
      id: 'timeline',
      isDefault: false,
      title: 'Timeline',
      template: TimelineTemplate,
      skeleton: TimelineTemplateSkeleton,
      schemaEnhancer: ({ schema, formData, intl }) => {
        let pos = addDefaultOptions(schema, formData, intl);

        pos = templatesOptions(
          schema,
          formData,
          intl,
          [
            'show_description',
            'hide_dates',
            'show_image',
            'natural_image_size',
          ],
          {
            hide_dates: { default: false },
            show_image: { label: "Mostra l'immagine" },
            natural_image_size: {
              default: false,
              label: "Non alterare le dimensioni naturali dell'immagine",
            },
          },

          pos,
        );

        addSchemaField(
          schema,
          'group_timeline_by',
          'Raggruppa la timeline per',
          null,
          {
            choices: [
              ['day', 'Giorno'],
              ['month', 'Mese'],
              ['year', 'Anno'],
            ],
            default: 'day',
          },
          pos,
        );
        pos++;

        addLinkMoreOptions(schema, formData, intl);
        return schema;
      },
      cloneData: cloneBlock,
    },
  ];
};
